import { useEffect, useState } from 'react';
import { Box, CircularProgress, Stack, TextField, Typography, useMediaQuery } from '@mui/material';
import Popup from '../../components/Popup';
import { useDispatch, useSelector } from 'react-redux';
import { addStuff } from '../../redux/userRelated/userHandle';
import { styled } from '@mui/material/styles';

const TealGoldButton = styled('button')(({ theme }) => ({
    background: 'linear-gradient(135deg, #008080, #FFD700)',
    color: '#fff',
    fontSize: '1rem',
    fontWeight: 'bold',
    padding: '12px 20px',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    width: '100%',
    '&:hover': {
        transform: 'scale(1.05)',
        boxShadow: '0px 4px 15px rgba(0, 128, 128, 0.3)'
    },
    '&:disabled': {
        background: '#ccc',
        cursor: 'not-allowed',
    }
}));

const StudentComplain = () => {
    const [complaint, setComplaint] = useState("");
    const [date, setDate] = useState("");
    const [loader, setLoader] = useState(false);
    const [message, setMessage] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const dispatch = useDispatch();
    const { status, currentUser, error } = useSelector(state => state.user);

    const user = currentUser._id;
    const school = currentUser.school._id;
    const address = "Complain";

    const fields = { user, date, complaint, school, userModel: 'student' };

    const submitHandler = (event) => {
        event.preventDefault();
        setLoader(true);
        dispatch(addStuff(fields, address));
    };

    useEffect(() => {
        if (status === "added") {
            setLoader(false);
            setShowPopup(true);
            setMessage("Done Successfully");
        } else if (error) {
            setLoader(false);
            setShowPopup(true);
            setMessage("Network Error");
        }
    }, [status, error]);

    const isMobile = useMediaQuery('(max-width:600px)');

    return (
        <>
            <Box
                sx={{
                    flex: '1 1 auto',
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, #008080, #004D4D)',
                    minHeight: '100vh',
                    padding: isMobile ? '10px' : '20px'
                }}
            >
                <Box
                    sx={{
                        maxWidth: 500,
                        px: isMobile ? 2 : 3,
                        py: isMobile ? '30px' : '50px',
                        width: '100%',
                        background: 'white',
                        borderRadius: '10px',
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
                        textAlign: 'center'
                    }}
                >
                    <Stack spacing={2} sx={{ mb: 3 }}>
                        <Typography variant={isMobile ? "h5" : "h4"} sx={{ color: '#008080', fontWeight: 'bold' }}>
                            Submit Your Complaint
                        </Typography>
                    </Stack>
                    <form onSubmit={submitHandler}>
                        <Stack spacing={3}>
                            <TextField
                                fullWidth
                                label="Select Date"
                                type="date"
                                value={date}
                                onChange={(event) => setDate(event.target.value)}
                                required
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#008080',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#FFD700',
                                        },
                                    },
                                }}
                            />
                            <TextField
                                fullWidth
                                label="Write your complaint"
                                variant="outlined"
                                value={complaint}
                                onChange={(event) => setComplaint(event.target.value)}
                                required
                                multiline
                                maxRows={4}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#008080',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#FFD700',
                                        },
                                    },
                                }}
                            />
                        </Stack>
                        <TealGoldButton type="submit" disabled={loader} sx={{ mt: 3 }}>
                            {loader ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                        </TealGoldButton>
                    </form>
                </Box>
            </Box>
            <Popup message={message} setShowPopup={setShowPopup} showPopup={showPopup} />
        </>
    );
};

export default StudentComplain;